import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  formControl: {
    '& .MuiInputLabel-shrink': {
      opacity: '0'
    }
  }
}));
